import {Directive, ElementRef, Renderer, HostListener} from '@angular/core';

@Directive({
    selector: '[jhiInputRequired]'
})
export class InputRequiredDirective {
    constructor(private el: ElementRef, private renderer: Renderer) {}

    @HostListener('blur') onBlur() {
        if ((!this.el.nativeElement.value ||
            this.el.nativeElement.value === '' ||
            this.el.nativeElement.value === '0: null') && this.el.nativeElement.required !== false) {
            this.renderer.setElementClass(this.el.nativeElement, 'inputRequired', true);
        } else {
            this.renderer.setElementClass(this.el.nativeElement, 'inputRequired', false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/input/input-required.directive.ts